module.exports = __webpack_public_path__ + "media/St 4-computer-correct.deba147d.wav";